import { CalendarEventDTO } from './calendar-event.dto';
import { CalendarEventCategoryDTO } from './calendar-event-category.dto';

export class CalendarEventListDTO {

    type: number;

    status: number;

    start: string | Date;

    end: string | Date;

    allDay: boolean;

    recurrence: string;

    duration: number;

    reminderType: number;

    reminderUnit: number;

    reminderValue: number;

    categories: Array<CalendarEventCategoryDTO>;

    event: CalendarEventDTO;

}
